import api from "!../../../../../../../../../ensotyres/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../../../ensotyres/node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!../../../../../../../../../ensotyres/node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../../../../ensotyres/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!../../../../../../../../../ensotyres/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-12.use[3]!../../../../../../../../../ensotyres/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LifetimeGuarantee.vue?vue&type=style&index=0&id=263cab4f&lang=scss&scoped=true";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};